export enum CounterMode {
  Increase,
  Decrease,
  Delete,
}
